import { render } from "./index.vue?vue&type=template&id=4cbca077&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Pages/Admin/Plays/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4cbca077"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4cbca077', __exports__)) {
    api.reload('4cbca077', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=4cbca077&ts=true", () => {
    api.rerender('4cbca077', render)
  })

}


export default __exports__